import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

const TicketCardSkeleton = ({ className, ...props }) => (
  <StyledTicketCardSkeletonWrapper className={className}>
    <ContentLoader
      speed={2}
      width={280}
      height={160}
      viewBox="0 0 280 160"
      backgroundColor="#e6e6e6"
      foregroundColor="#ffffff"
      uniqueKey="ticketcard-skeleton"
      {...props}
    >
      <rect x="65" y="37" rx="3" ry="3" width="170" height="14" />
      <rect x="65" y="25" rx="3" ry="3" width="110" height="8" />
      <rect x="65" y="55" rx="3" ry="3" width="126" height="8" />
      <circle cx="30" cy="45" r="20" />
      <rect x="10" y="100" rx="6" ry="6" width="135" height="16" />
      <rect x="10" y="126" rx="6" ry="6" width="90" height="10" />
    </ContentLoader>
  </StyledTicketCardSkeletonWrapper>
);

const StyledTicketCardSkeletonWrapper = styled.div`
  width: 280px;
  background: #f5f3f2;
  border-radius: 4px;
`;

export default TicketCardSkeleton;
